import { render, staticRenderFns } from "./FpregradCreate.vue?vue&type=template&id=683fda2d&"
import script from "./FpregradCreate.vue?vue&type=script&lang=js&"
export * from "./FpregradCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports